let store = {}

export default class {
    static set(key, data) {
        store[key] = data
    }

    static get(key) {
        const value = store[key]

        return value === undefined ? null : value
    }

    static all() {
        return store
    }

    static remove(key) {
        delete store[key]
    }
}
